import React , { useState, useRef, useEffect } from "react";
import {GridWrap, ListWrap, Elements} from "./helpers";
import app from "./app";

export const ContactFormOne = ({data, device, widgetType, mode}) => {

    const domEle = useRef();
    useEffect(()=> {
        if(mode == "live"){
            const submitButton = domEle.current.querySelector("#primaryButton");
            submitButton.addEventListener('click' , function(){
                submitDetails();
            });
            const inputItems = domEle.current.querySelectorAll(".elements-grid input, .elements-grid textarea");
            inputItems.forEach(function(v){
                v.addEventListener("input", function(e){
                    e.currentTarget.value = stripHTML(e.currentTarget.value)
                })
            })
        }
    },[]);

    const stripHTML = function(input) {
        return input.replace(/<[^>]*>/g, '');
    }

    // generate email html
    const generateEmailHtml = (emailSubject) => {
        const inputItems = domEle.current.querySelectorAll(".elements-grid");
        let emailHtml = `<table style="width:500px;margin:50px auto 10px;background-color: #fafafa;border-top: solid 7px #131313;">
        <tbody>
            <tr>
                <td style="padding:0 20px;">
                    <h2>${emailSubject}</h2>
                </td>
            </tr> 
            <tr>
                <td style="padding: 20px; padding-top: 0;">
                <table style="width: 100%; background: #f7f7f7; font-size: 13px; border-collapse:collapse;" cellpadding="8" border="1px solid #000">`;

        formError = true;
        formErrorText = "";

        inputItems.forEach(item => {
            const labelTag = item.querySelector('#label');
            const label = labelTag.innerText;
            const input = item.querySelector('#input');
            const value = input?.value.trim() || '';
            // validateForm(value, input);
            if(labelTag.classList.contains('required')){
                validateForm(value, input);
            }
            emailHtml += `<tr>
                <td width="30%"><b>${label}</b></td>
                <td>${value}</td>
            </tr>
            `;
        });

        emailHtml += '</table></td></tr></tbody></table>';
        return formError ? emailHtml : null;
    }

    const requiredFieldsErrorText = data.lang.required_fields;
    const emailErrorText = data.lang.valid_email;
    const phoneErrorText = data.lang.valid_phone;

    // form validation
    let formError = true;
    let formErrorText = "";

    const validateForm = (value,input) => {
        if(value === ""){
            formErrorText = requiredFieldsErrorText;
            formError = false;
            return;
        }
        if(input.type == "email"){
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if(!emailPattern.test(value)){
                formError = false;
                formErrorText = emailErrorText;
            }
        }
        if(input.type == "tel"){
            // const phonePattern = /^[0-9]{10}$/;

            const digitCount = value.replace(/[^0-9]/g, "").length; // Count only digits
            const phonePattern = /^[0-9+\- ]+$/; // Allows digits, +, -, and spaces

            if (!phonePattern.test(value) || digitCount !== 10) {
                formError = false;
                formErrorText = phoneErrorText;
            }
        }
    }

    const clearFormFields = () => {
        const inputItems = document.querySelectorAll(`[widget-type='${widgetType}'] .elements-grid #input`);
        inputItems.forEach(input => {
            input.value = '';
        });
    }

    const pageLoader = (a) => {
        const loader = document.querySelector('.page-preloader');
        if (a) {
            loader.style.display = "block";
        } else {
            loader.style.display = "none";
        }
    }
      

    // form submit form
    const submitDetails = async () => {
        let emailSubject = data.lang.mail_subject;
        let emailRecipient = data.properties.email;
        if(emailRecipient === "") {
            if(localStorage.getItem("userAdminEmail")) {
                emailRecipient = localStorage.getItem("userAdminEmail");
            }
        } 

        let thanks_msg =  data.lang.thanks_msg;

        const emailHtml = generateEmailHtml(emailSubject);

        if(!formError){
            alert(formErrorText);
            return;
        }

        pageLoader(true);

        // try{
        //     const data = await app.fetchPost({
        //         method : 'sendMailTemplate',
        //         to: emailRecipient,
        //         subject : emailSubject,
        //         html: emailHtml
        //     });

        //     console.log('Email sent successfully:', data);

        //     if(data.status){
        //         pageLoader(false);
        //         alert(thanks_msg);
        //         clearFormFields();
        //     }
        // }
        // catch(error){
        //     console.error('Error In Send Mail', error);
        // }

    }


    let inputList = "";
    if(data.elements.inputList){
        inputList = data.elements.inputList.items.map((v,i) => {
            return <GridWrap data={v} key={'key-' + v.gridId + i} id="inputList" mode={mode} device={device}>
                <Elements row={v.label} id={"label"} device={device} classType={v.properties.mandatory ? "required" : ''}/> 
                <Elements row={v.input} id={"input"} device={device} classType={v.properties.placeholder !== true ? 'hide-placeholder' : ''}/> 
            </GridWrap>
        })

        inputList = <ListWrap data={data.elements.inputList} grid={true} mode={mode} className="align-items-stretch">
                    {inputList}
            </ListWrap>
    }

    console.log(data,"contact_form_one");

    const layout = data.properties.layout;
    console.log(layout,"contact_form_one_layout");

    if(layout === "2"){
        return <div className="container-fluid p-0 position-relative" ref={domEle}>
        <div className="row">
            <div className="col-md-5">
                <Elements row={data.elements.banner} id={"banner"} device={device}/>
                <Elements row={data.elements.heading} id={"heading"} device={device}/>
                <Elements row={data.elements.summary} id={"summary"} device={device} /> 
            </div>
            <div className="col-md-7">
                {inputList}
                <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} /> 
            </div>

        </div>
    </div>
    }

    if(layout === "3"){
        return <div className="container-fluid p-0 position-relative" ref={domEle}>
        <div className="row">
            <div className="col-md-5">
                <Elements row={data.elements.banner} id={"banner"} device={device}/>
            </div>
            <div className="col-md-7">
                <Elements row={data.elements.heading} id={"heading"} device={device}/>
                <Elements row={data.elements.summary} id={"summary"} device={device} /> 
                {inputList}
                <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} /> 
            </div>

        </div>
    </div>
    }

    return <div className="container-fluid p-0 position-relative" ref={domEle}>
    <div className="row">
        <div className="col-12">
            <Elements row={data.elements.banner} id={"banner"} device={device}/>
            <Elements row={data.elements.heading} id={"heading"} device={device}/>
            <Elements row={data.elements.summary} id={"summary"} device={device} /> 
            {inputList}
            <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} /> 
        </div>
    </div>
</div>
}
